// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var SubTypes;
(function (SubTypes) {
    SubTypes[SubTypes["AUCTION_PRE_CROSS"] = 0] = "AUCTION_PRE_CROSS";
    SubTypes[SubTypes["AUCTION_FREEZE"] = 1] = "AUCTION_FREEZE";
    SubTypes[SubTypes["CONTINUOUS"] = 2] = "CONTINUOUS";
    SubTypes[SubTypes["IN_BETWEEN_CLEARING"] = 3] = "IN_BETWEEN_CLEARING";
    SubTypes[SubTypes["SETTLEMENT_CLEARING"] = 4] = "SETTLEMENT_CLEARING";
})(SubTypes || (SubTypes = {}));
